export const validateBid = (value, lotStartingPrice, auctionBidSteps) => {
    let type = 'error';
    let content = '';
    if (
        typeof value === 'number' &&
        isFinite(value) &&
        Math.floor(value) === value &&
        value > 0
    ) {
        if (value === 0 || value === '') {
            content = 'bid_errors_empty';
        } else {
            if (value < lotStartingPrice) {
                content = 'bid_errors_tooLow';
            } else if (auctionBidSteps) {
                // bypass step validation if bid equals starting price
                if (value === lotStartingPrice) {
                    type = 'success';
                    content = 'bid_success';
                    return { type, content };
                }

                const currentStep = auctionBidSteps.pretty.filter(step => {
                    const valueGreaterStart = value >= step.start;
                    const valueLessEnd = step.end ? value <= step.end : true;
                    return valueGreaterStart && valueLessEnd;
                })[0];

                if (currentStep && !isValidValue(currentStep.start, currentStep.step, value)) {
                    content = 'bid_errors_steps';
                } else {
                    type = 'success';
                    content = 'bid_success';
                }
            } else {
                type = 'success';
                content = 'bid_success';
            }
        }
    } else {
        content = 'bid_errors_invalid';
    }

    return {
        type,
        content,
    };
};

function isValidValue(start, step, value) {
    return (value - start) % step === 0;
}



export const validateIncrease = value => {
    let type = 'error';
    let content = '';

    if (
        typeof value === 'number' &&
        isFinite(value) &&
        Math.floor(value) === value &&
        value >= 0 &&
        value <= 100
    ) {
        if (value === '') {
            content = 'bid_increase_errors_empty';
        } else {
            type = 'success';
            content = 'bid_increase_success';
        }
    } else {
        content = 'bid_increase_errors_invalid';
    }

    return {
        type,
        content,
    };
};
